import * as Yup from 'yup';

import { formatPhoneNumber } from '../../utils/util';

import Mobile from './Components/Mobile';

const headers = [
  {
    label: 'Name',
    id: 'full_name'
  },
  {
    label: 'Email',
    id: 'email'
  },
  {
    label: 'Phone',
    id: 'mobile_phone',
    render: (row) => formatPhoneNumber(row.mobile_phone)
  },
  {
    label: 'Address',
    id: 'address'
  },
  {
    label: "Balance",
    balance: true,
    id: "final_balance"
  },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  },
  {
    label: "Wedding Date",
    id: "wedding_date",
    dateShort: true
  }
];

const mobile_headers = [
  {
    label: 'Name',
    id: 'full_name'
  },
  {
    label: 'Phone',
    id: 'mobile_phone',
    render: (row) => formatPhoneNumber(row.mobile_phone)
  },
  {
    label: "Balance",
    currency: true,
    id: "final_balance"
  }
]

const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  },
  {
    id: "balance",
    type: "balance",
    label: "Balance",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "first_name",
    label: "First Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "last_name",
    label: "Last Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "email",
    label: "Email",
    type: "email",
    size: {xs: 12, lg: 4},
  },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "mobile_phone",
  //   label: "Mobile Phone",
  //   type: "phone",
  //   size: {xs: 12, lg: 4},
  // },
  {
    fieldType: "Component",
    Component: <Mobile />,
    name: "mobile_phone",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType:"mask" ,
    name: "home_phone",
    label: "Home Phone",
    placeholder:"(XXX) XXX-XXXX",
    maskFormat: "(###) ###-####",
    maskChar: [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "wedding_date",
    label: "Wedding Date",
    type: "date",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Address Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "address",
    label: "Address",
    type: "text",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "city",
    label: "City",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "state",
    label: "State",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "zip",
    label: "Zip",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "country",
    label: "Country",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "divider",
    header: "Account Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "notes",
    label: "Notes",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12, lg: 8},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  }
]

const initialValues = {
  first_name: '',
  last_name: '',
  email: '',
  mobile_phone: '',
  home_phone: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  wedding_date: '',
  is_active: true
}

const schema = Yup.object().shape({
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().required('Last Name is required'),
  email: Yup.string().email('Invalid email address').nullable(),
  mobile_phone: Yup.string().min(10).max(10).notRequired(),
  home_phone: Yup.string().min(10).max(10).notRequired(),
  address: Yup.string().nullable(),
  city: Yup.string().nullable(),  
  state: Yup.string().nullable(),
  zip: Yup.string().nullable(),
  country: Yup.string().nullable(),
  is_active: Yup.boolean()
});

export { mobile_headers, headers, filters, fields, schema, initialValues };